import { render, staticRenderFns } from "./InfinityUpgradeButton.vue?vue&type=template&id=3f9d9d74&scoped=true&"
import script from "./InfinityUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./InfinityUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d9d74",
  null
  
)

export default component.exports